import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';

import PrestacionesList from './PrestacionesList';
import PrestacionesShow from './PrestacionesShow';

const prestaciones = {
    icon: ViewListOutlinedIcon,
    list: PrestacionesList,
    show: PrestacionesShow,
};

export default prestaciones;
